module.exports = __webpack_public_path__ + "img/z5.8eff5bf4.png";